import {View, Text, TouchableOpacity} from 'react-native';
import React from 'react';
import {styles} from './styles';
import EquipamentCard from '../EquipamentList/EquipamentList';
import {ISolicitation} from '../../../../types/Equipaments';

interface IEquipamentResume {
  name: string;
  status: string;
  date: string;
  item: ISolicitation;
}

const EquipamentResume = ({name, date, status, item}: IEquipamentResume) => {
  const [coreName, model] = name.split(' - ');
  const [visible, setVisible] = React.useState(false);

  return (
    <TouchableOpacity
      style={styles.container}
      onPress={() => setVisible(!visible)}>
      <Text style={styles.label}>{coreName}</Text>
      <View style={styles.ContainerData}>
        <View>
          <Text
            style={[
              styles.dateText,
              {
                color:
                  status.toLowerCase() === 'concluído'
                    ? 'green'
                    : status.toLowerCase() === 'reprovada'
                    ? 'darkred'
                    : 'gray',
              },
            ]}>
            Status: {status[0].toUpperCase() + status.slice(1).toLowerCase()}
          </Text>
        </View>
        <View>
          <Text style={styles.dateText}>{model}</Text>
        </View>
      </View>
      {visible && (
        <EquipamentCard name={name} status={status} date={date} item={item} />
      )}
    </TouchableOpacity>
  );
};

export default EquipamentResume;
